export default "__VITE_ASSET__lZci9Dzr__"